import { LoginGuard } from './login-guard.service';
import { AuthGuard } from './auth-guard.service';
import { AppConfigLoader } from './shared/app-config.loader';
var routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', loadChildren: 'app/login/login.module#LoginModule', canActivate: [LoginGuard] },
    { path: '', loadChildren: 'app/dashboard/index.module#DashboardModule', canActivate: [AuthGuard] },
];
var ɵ0 = AppConfigLoader;
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/app-routing.module.ts.pre-build-optimizer.js